export default (code) => {
    const script = window.document.createElement('script');
    script.setAttribute('type', 'application/javascript');
    script.setAttribute('async', true);
    script.setAttribute('src', `//api.usersnap.com/load/${code}.js`);
    window.document.querySelector('body').appendChild(script);
};
